import ReactDOM from 'react-dom';
import App from './App';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
ReactDOM.render(


  <GoogleOAuthProvider clientId="140747619313-uu606vtnspi52vh5b3iasnhhb7ve86q3.apps.googleusercontent.com">

    <App />
  </GoogleOAuthProvider>
  , document.getElementById('root'));